import { Organization }          from '@app/modules/organization/models/organization.model';
import { OrganizationState }     from '@app/modules/organization/store/organization.state';
import { adapterSelectors }      from '@core/store/adapter/adapter.selectors';
import { apiSelectors }          from '@core/store/api/api.selectors';
import { EntityAdapter }         from '@ngrx/entity';
import { createFeatureSelector } from '@ngrx/store';
import { LoggerService }         from '@shared/services/logger.service';


export function organizationSelector(
	adapter: EntityAdapter<Organization>,
	storeId: string,
	logger: LoggerService
) {
	const organizationStateSelector = createFeatureSelector<OrganizationState>( storeId );
	const adapterSelector = { ...adapterSelectors<Organization, OrganizationState>( adapter, organizationStateSelector ) };


	return {
		adapterSelector,
		...apiSelectors<Organization, OrganizationState>( adapter, adapterSelector )
	};
}

